import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-41b3fb42")

_pushScopeId("data-v-41b3fb42")
const _hoisted_1 = { class: "card-body-cashier-station" }
const _hoisted_2 = {
  key: 0,
  class: "new-entity-btn-row"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle pr-20" }, null, -1)
const _hoisted_4 = { class: "cashier-stations" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "row stations-row" }
const _hoisted_7 = { class: "col-3" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "token-number" }
const _hoisted_11 = { class: "col-3" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "content" }
const _hoisted_14 = { class: "token-number" }
const _hoisted_15 = { class: "col-3" }
const _hoisted_16 = { class: "default-title" }
const _hoisted_17 = {
  key: 0,
  class: "default-text"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "col-2" }
const _hoisted_20 = { class: "default-title" }
const _hoisted_21 = { class: "mx-2" }
const _hoisted_22 = { class: "default-title" }
const _hoisted_23 = {
  class: "default-text provider-status desktop",
  style: {"font-size":"15px"}
}
const _hoisted_24 = {
  key: 0,
  class: "status-green"
}
const _hoisted_25 = {
  key: 1,
  class: "status-red"
}
const _hoisted_26 = {
  key: 0,
  class: "col-1"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("i", {
  class: "icon-f icon-delete-cross fs-16",
  style: {"color":"#fd695a"}
}, null, -1)
const _hoisted_28 = { class: "col-3 mt-2" }
const _hoisted_29 = { class: "default-title" }
const _hoisted_30 = {
  key: 0,
  class: "default-text"
}
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "col-3 mt-2" }
const _hoisted_33 = { class: "default-title" }
const _hoisted_34 = {
  key: 0,
  class: "default-text"
}
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "col-3 mt-2" }
const _hoisted_37 = { class: "default-title" }
const _hoisted_38 = {
  key: 0,
  class: "default-text"
}
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "col-3 mt-2" }
const _hoisted_41 = { class: "default-title" }
const _hoisted_42 = {
  key: 0,
  class: "default-text"
}
const _hoisted_43 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.editMode)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("button", {
            type: "button",
            class: "new-entity-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addStation()))
          }, [
            _hoisted_3,
            _createTextVNode(_toDisplayString(_ctx.$t('btn.new-station')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_4, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (station, index) => {
        return (_openBlock(), _createBlock("div", {
          class: ["row cashier-station-row", { 'mt-16': index != 0 }],
          key: index
        }, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('cashier.station.cashierGuid')), 1),
                _createVNode("div", _hoisted_9, [
                  _createVNode("div", _hoisted_10, _toDisplayString(station.cashierGuid), 1)
                ])
              ]),
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('cashier.station.deviceGuid')), 1),
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, _toDisplayString(station.deviceGuid), 1)
                ])
              ]),
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('cashier.station.stationName')), 1),
                _createVNode("div", null, [
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_17, [
                        (_ctx.editMode)
                          ? _withDirectives((_openBlock(), _createBlock("input", {
                              key: 0,
                              type: "text",
                              class: "bookit-input form-control",
                              "onUpdate:modelValue": ($event: any) => (station.stationName = $event)
                            }, null, 8, ["onUpdate:modelValue"])), [
                              [_vModelText, station.stationName]
                            ])
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_18, _toDisplayString(station.stationName), 1))
                ])
              ]),
              _createVNode("div", _hoisted_19, [
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('cashier-station-status-title')), 1),
                      _createVNode("div", _hoisted_21, [
                        _withDirectives(_createVNode("input", {
                          type: "checkbox",
                          class: "toggle",
                          checked: station.active,
                          "onUpdate:modelValue": ($event: any) => (station.active = $event)
                        }, null, 8, ["checked", "onUpdate:modelValue"]), [
                          [_vModelCheckbox, station.active]
                        ])
                      ])
                    ], 64))
                  : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _createVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('cashier-station-status-title')), 1),
                      _createVNode("div", _hoisted_23, [
                        (station.active)
                          ? (_openBlock(), _createBlock("span", _hoisted_24, _toDisplayString(_ctx.$t('label.active')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_25, _toDisplayString(_ctx.$t('label.notactive')), 1))
                      ])
                    ], 64))
              ]),
              (_ctx.editMode)
                ? (_openBlock(), _createBlock("div", _hoisted_26, [
                    _createVNode("div", {
                      class: "text-r",
                      onClick: ($event: any) => (_ctx.deleteStation(station.id))
                    }, [
                      _hoisted_27
                    ], 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_28, [
                _createVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('providers.accounting.paymentUsername')), 1),
                _createVNode("div", null, [
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_30, [
                        (_ctx.editMode)
                          ? _withDirectives((_openBlock(), _createBlock("input", {
                              key: 0,
                              type: "text",
                              class: "bookit-input form-control",
                              "onUpdate:modelValue": ($event: any) => (station.pelecardUsername = $event),
                              required: !!(station.pelecardUsername || station.pelecardTerminal || station.pelecardPassword)
                            }, null, 8, ["onUpdate:modelValue", "required"])), [
                              [_vModelText, station.pelecardUsername]
                            ])
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_31, _toDisplayString(station.pelecardUsername), 1))
                ])
              ]),
              _createVNode("div", _hoisted_32, [
                _createVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('providers.accounting.paymentTerminal')), 1),
                _createVNode("div", null, [
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_34, [
                        (_ctx.editMode)
                          ? _withDirectives((_openBlock(), _createBlock("input", {
                              key: 0,
                              type: "text",
                              class: "bookit-input form-control",
                              "onUpdate:modelValue": ($event: any) => (station.pelecardTerminal = $event),
                              required: !!(station.pelecardUsername || station.pelecardTerminal || station.pelecardPassword)
                            }, null, 8, ["onUpdate:modelValue", "required"])), [
                              [_vModelText, station.pelecardTerminal]
                            ])
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_35, _toDisplayString(station.pelecardTerminal), 1))
                ])
              ]),
              _createVNode("div", _hoisted_36, [
                _createVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('providers.accounting.paymentPassword')), 1),
                _createVNode("div", null, [
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_38, [
                        (_ctx.editMode)
                          ? _withDirectives((_openBlock(), _createBlock("input", {
                              key: 0,
                              type: "text",
                              class: "bookit-input form-control",
                              "onUpdate:modelValue": ($event: any) => (station.pelecardPassword = $event)
                            }, null, 8, ["onUpdate:modelValue"])), [
                              [_vModelText, station.pelecardPassword]
                            ])
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_39, _toDisplayString(station.pelecardPassword), 1))
                ])
              ]),
              _createVNode("div", _hoisted_40, [
                _createVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('providers.accounting.paymentShopNo')), 1),
                _createVNode("div", null, [
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_42, [
                        (_ctx.editMode)
                          ? _withDirectives((_openBlock(), _createBlock("input", {
                              key: 0,
                              type: "number",
                              class: "bookit-input form-control",
                              "onUpdate:modelValue": ($event: any) => (station.pelecardShopNumber = $event)
                            }, null, 8, ["onUpdate:modelValue"])), [
                              [_vModelText, station.pelecardShopNumber]
                            ])
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_43, _toDisplayString(station.pelecardShopNumber), 1))
                ])
              ])
            ])
          ])
        ], 2))
      }), 128))
    ])
  ]))
})